module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('div', {
    staticClass: "col-sm-12 form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.componentTitle) ? _c('label', {
    staticClass: "col-sm-4"
  }, [_vm._v(_vm._s(_vm.componentTitle))]) : (_vm.displayTitle) ? _c('label', {
    staticClass: "col-sm-4"
  }, [_vm._v(_vm._s(_vm.labelTitle))]) : _vm._e(), _vm._v(" "), (!_vm.personOnly) ? _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchType),
      expression: "searchType"
    }],
    staticClass: "col-sm-1",
    attrs: {
      "disabled": !_vm.isEditable,
      "id": "individual",
      "type": "radio"
    },
    domProps: {
      "value": "individual",
      "checked": _vm._q(_vm.searchType, "individual")
    },
    on: {
      "change": function($event) {
        _vm.searchType = "individual"
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "col-sm-1",
    attrs: {
      "for": "individual"
    }
  }, [_vm._v("Person")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchType),
      expression: "searchType"
    }],
    staticClass: "col-sm-1",
    attrs: {
      "disabled": !_vm.isEditable,
      "id": "organisation",
      "type": "radio"
    },
    domProps: {
      "value": "organisation",
      "checked": _vm._q(_vm.searchType, "organisation")
    },
    on: {
      "change": function($event) {
        _vm.searchType = "organisation"
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "col-sm-1",
    attrs: {
      "for": "organisation"
    }
  }, [_vm._v("Organisation")])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-9"
  }, [_c('input', {
    ref: "search_person_org",
    class: _vm.classNames,
    attrs: {
      "id": _vm.elemId,
      "readonly": !_vm.isEditable
    }
  })]), _vm._v(" "), (_vm.showCreateNewPerson) ? _c('div', {
    staticClass: "col-sm-2"
  }, [_c('input', {
    staticClass: "btn btn-primary",
    attrs: {
      "disabled": !_vm.isEditable,
      "type": "button",
      "value": "Create New Person"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.createNewPerson()
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.showClearPerson) ? _c('div', {
    staticClass: "col-sm-2"
  }, [_c('input', {
    staticClass: "btn btn-primary",
    attrs: {
      "disabled": !_vm.isEditable,
      "type": "button",
      "value": "Clear Person"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.clearPerson()
      }
    }
  })]) : (_vm.showCreateNewOrganisation) ? _c('div', {
    staticClass: "col-sm-2"
  }, [_c('input', {
    staticClass: "btn btn-primary",
    attrs: {
      "disabled": !_vm.isEditable,
      "type": "button",
      "value": "Create New Organisation"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.createNewOrganisation($event)
      }
    }
  })]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.displayUpdateCreatePerson) ? _c('div', {
    staticClass: "col-sm-12"
  }, [_c('updateCreatePerson', {
    key: _vm.updateCreatePersonBindId,
    ref: "update_create_person",
    attrs: {
      "displayComponent": "",
      "isEditable": _vm.isEditable,
      "personToUpdate": _vm.entity.id
    },
    on: {
      "person-saved": _vm.savePerson
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.displayUpdateCreateOrganisation && !_vm.personOnly) ? _c('div', {
    staticClass: "col-sm-12"
  }, [_c('updateCreateOrganisation', {
    ref: "update_create_organisation",
    attrs: {
      "displayComponent": ""
    },
    on: {
      "organisation-saved": function($event) {}
    }
  })], 1) : _vm._e()])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-25586c2d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/search_person_or_organisation.vue
// module id = 940
// module chunks = 0